/**
****************************************************************************************
Project: Readabl
File: App.js
Description: This file renders Entry file.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React, { Suspense } from "react";
import "./App.css";
import "./common.css";
import Entry from './container/Entry';
import { CircularProgress } from "@mui/material";
class App extends React.Component {
  render() {
  
    return (
      <div className="App">
      
        <Suspense fallback={<><CircularProgress style={{ color: "grey", margin: "40vh auto" }} /></>}>
          <Entry className="full-height" />
        </Suspense>
      
     </div>
    );
  }
}

export default App;
